import AddLinkToCustomer from "./Link-To-Customer/AddLinkToCustomer";
import LinkToCustomer from "./Link-To-Customer/LinkToCustomer";
import PaymentTerms from "./PaymentTerms";

const PaymentTermsConfig = {
    settings: {
        layout: {
            config: {},
        },
    },
    routes: [
        {
            path: '/payment-terms',
            element: <PaymentTerms />,
        },
        {
            path: '/linkToCustomer',
            element: <LinkToCustomer />,
        },
        {
            path: '/AddLinkToCustomer',
            element: <AddLinkToCustomer />,
        },
    ],
}

export default PaymentTermsConfig;
